var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row mb-5" },
    [
      _c("section-headline", {
        attrs: { edit: _vm.isEditing, hasEdit: true, msg: "Meine Infos" },
        on: {
          click: function(payload) {
            return (this$1.isEditing = payload)
          }
        }
      }),
      _vm._v(" "),
      _vm.isFetching
        ? _c("loader")
        : _c(
            "transition-group",
            {
              staticClass: "col-12",
              attrs: { mode: "in-out", name: "slide", tag: "div" }
            },
            [
              !_vm.isFetching && !_vm.isEditing
                ? _c("div", { key: 1, staticClass: "row col-12" }, [
                    _c(
                      "div",
                      { staticClass: " col-12 col-lg-4 mb-4 mb-lg-0 " },
                      [
                        _c("img", {
                          staticClass: "image rounded-lg w-100",
                          attrs: { src: _vm.imagePath, alt: "Markt Foto" }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "image rounded-lg w-100 mt-4 d-block",
                          attrs: { src: _vm.portraitPath, alt: "Markt Foto" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "contact col-12 col-md-6 col-lg-4 mb-3" },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("block-headline", {
                              attrs: { icon: "id-badge", text: "Kontakt" }
                            }),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "list-group list-group-flush" },
                              [
                                _vm.element.address[0].zip &&
                                _vm.element.address[0].city
                                  ? _c("opening-list-item", {
                                      attrs: {
                                        text:
                                          _vm.element.address[0].zip +
                                          " " +
                                          _vm.element.address[0].city,
                                        icon: "fa-globe"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.element.address[0].street
                                  ? _c("opening-list-item", {
                                      attrs: {
                                        text: _vm.element.address[0].street,
                                        icon: "fa-map-marker-alt"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.element.contact[0].phone
                                  ? _c("opening-list-item", {
                                      attrs: {
                                        text: _vm.element.contact[0].phone,
                                        icon: "fa-phone"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.element.contact[0].fax
                                  ? _c("opening-list-item", {
                                      attrs: {
                                        text: _vm.element.contact[0].fax,
                                        icon: "fa-fax"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.element.contact[0].email
                                  ? _c("opening-list-item", {
                                      attrs: {
                                        text: _vm.element.contact[0].email,
                                        icon: "fa-envelope"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.element.contact[0].website
                                  ? _c("opening-list-item", {
                                      attrs: {
                                        text: _vm.element.contact[0].website,
                                        icon: "fa-browser"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "time col-12 col-md-6 col-lg-4 mb-3" },
                      [
                        _c("block-headline", {
                          attrs: { icon: "clock", text: "Öffnungszeiten" }
                        }),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "list-group list-group-flush" },
                          _vm._l(7, function(hour, index) {
                            return _c(
                              "li",
                              { key: index, staticClass: "list-group-item" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group d-flex justify-content-between align-items-center m-0"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "m-0 min-width" },
                                      [
                                        _c("p", { staticClass: "m-0" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.displayWeekday(index + 1)
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "w-100 ml-3" }, [
                                      _c("p", {
                                        staticClass:
                                          "m-0 text-right d-flex flex-column",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.displayOpening(
                                              _vm.element.openings[0][index + 1]
                                            )
                                          )
                                        }
                                      })
                                    ])
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _vm.element.hybrid_market.value
                          ? [
                              _c("block-headline", {
                                staticClass: "whitespace-nowrap",
                                attrs: {
                                  icon: "shopping-bag",
                                  text: "Hybridmarkt Öffnungszeiten"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(7, function(hour, index) {
                                  return _c(
                                    "li",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.element.hybrid_openings[0][
                                              index + 1
                                            ],
                                          expression:
                                            "element.hybrid_openings[0][index + 1]"
                                        }
                                      ],
                                      key: index,
                                      staticClass: "list-group-item"
                                    },
                                    [
                                      _vm.element.hybrid_openings[0][index + 1]
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group d-flex justify-content-between align-items-center m-0"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "m-0 min-width"
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    { staticClass: "m-0" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.displayWeekday(
                                                            index + 1
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "w-100 ml-3" },
                                                [
                                                  _c("p", {
                                                    staticClass:
                                                      "m-0 text-right d-flex flex-column",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.displayOpening(
                                                          _vm.element
                                                            .hybrid_openings[0][
                                                            index + 1
                                                          ]
                                                        )
                                                      )
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          : _c(
                              "h4",
                              [
                                _c("block-headline", {
                                  attrs: {
                                    icon: "shopping-bag",
                                    text: "Kein Hybridmarkt"
                                  }
                                })
                              ],
                              1
                            )
                      ],
                      2
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isFetching && _vm.isEditing
                ? _c(
                    "div",
                    { key: 2 },
                    [
                      _c(
                        "FormulateForm",
                        {
                          staticClass: "mb-5 col-12",
                          attrs: {
                            "keep-model-data": true,
                            errors: _vm.inputErrors
                          },
                          on: { submit: _vm.submitForm },
                          model: {
                            value: _vm.element,
                            callback: function($$v) {
                              _vm.element = $$v
                            },
                            expression: "element"
                          }
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "row" },
                                [
                                  _c("block-headline", {
                                    staticClass: "col-12",
                                    attrs: {
                                      icon: "map-marker-alt",
                                      text: "Standort"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("FormulateInput", {
                                    staticClass: "col-12",
                                    attrs: {
                                      aspectRatio: 4 / 3,
                                      help:
                                        'Das Profilbild wird auf allen Endgeräten nahezu quadratisch angezeigt. Wenn Sie ein Bild hochladen, sehen Sie den erwarteten Ausschnitt als Markierung - bitte positionieren Sie den gewünschten Ausschnitt innerhalb der Markierung und klicken Sie auf "Speichern".',
                                      label: "Bild",
                                      name: "media",
                                      type: "cropper",
                                      "upload-behavior": "delayed",
                                      "validation-name": "Bild"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("FormulateInput", {
                                    staticClass: "col-12",
                                    attrs: {
                                      help: "Freigestelltes Foto",
                                      label: "Portrait",
                                      name: "portrait",
                                      type: "file",
                                      "upload-behavior": "delayed",
                                      "validation-name": "Portrait"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("FormulateInput", {
                                    staticClass: "col-12",
                                    attrs: {
                                      address: _vm.element.address[0],
                                      "prevent-deregister": true,
                                      settings: _vm.gmap.settings,
                                      visual: _vm.gmap.visual,
                                      label: "Google Maps Standort",
                                      name: "map",
                                      type: "map",
                                      validation: "optional",
                                      "validation-name": "Google Maps Standort"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("form-buttons", {
                                    attrs: { isLoading: _vm.isSubmitting },
                                    on: { cancel: _vm.cancelEdit }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("hr", { staticClass: "w-100" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "row" },
                                [
                                  _c("block-headline", {
                                    staticClass: "col-12",
                                    attrs: { icon: "id-badge", text: "Kontakt" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "FormulateInput",
                                    {
                                      staticClass: "col-12",
                                      attrs: {
                                        label: "Adressangaben",
                                        name: "address",
                                        type: "group"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          _c("FormulateInput", {
                                            staticClass: "col-6",
                                            attrs: {
                                              label: "Postleitzahl",
                                              name: "zip",
                                              placeholder: "Postleitzahl",
                                              validation: "required",
                                              type: "text",
                                              "validation-name": "Postleitzahl"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("FormulateInput", {
                                            staticClass: "col-6",
                                            attrs: {
                                              label: "Stadt",
                                              name: "city",
                                              placeholder: "Stadt",
                                              type: "text",
                                              validation: "required",
                                              "validation-name": "Stadt"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("FormulateInput", {
                                            staticClass: "col-12 col-md-6",
                                            attrs: {
                                              label: "Adresse",
                                              name: "street",
                                              placeholder: "Adresse",
                                              type: "text",
                                              validation: "required",
                                              "validation-name": "Adresse"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("FormulateInput", {
                                            staticClass: "col-12 col-md-6",
                                            attrs: {
                                              options: this.stateOptions,
                                              label: "Bundesland",
                                              name: "state",
                                              placeholder: "Bundesland",
                                              type: "multiselect",
                                              validation: "required",
                                              "validation-name": "Bundesland"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "FormulateInput",
                                    {
                                      staticClass: "col-12",
                                      attrs: {
                                        label: "Kontakt Informationen",
                                        name: "contact",
                                        type: "group"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          _c("FormulateInput", {
                                            staticClass: "col-12 col-md-6",
                                            attrs: {
                                              label: "Marktname",
                                              name: "name",
                                              placeholder: "Marktname",
                                              type: "tel",
                                              validation: "required",
                                              "validation-name": "Marktname"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("FormulateInput", {
                                            staticClass: "col-12 col-md-6",
                                            attrs: {
                                              label: "Telefonnummer",
                                              name: "phone",
                                              placeholder: "Telefonnummer",
                                              type: "tel",
                                              validation: "optional",
                                              "validation-name": "Telefonnummer"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("FormulateInput", {
                                            staticClass: "col-12 col-md-6",
                                            attrs: {
                                              label: "Fax",
                                              name: "fax",
                                              placeholder: "Fax",
                                              type: "tel",
                                              validation: "optional",
                                              "validation-name": "Fax"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("FormulateInput", {
                                            staticClass: "col-12 col-md-6",
                                            attrs: {
                                              label: "E-Mail Adresse",
                                              name: "email",
                                              placeholder: "E-Mail Adresse",
                                              type: "email",
                                              validation: "optional|^email",
                                              "validation-name":
                                                "E-Mail Adresse"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("FormulateInput", {
                                            staticClass: "col-12 col-md-6",
                                            attrs: {
                                              label: "Website",
                                              name: "website",
                                              placeholder: "Website",
                                              type: "url",
                                              help:
                                                "Eine valide URL beginnt mit http:// oder https://",
                                              validation: "optional|^url",
                                              "validation-name": "Website"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("form-buttons", {
                                    attrs: { isLoading: _vm.isSubmitting },
                                    on: { cancel: _vm.cancelEdit }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("hr", { staticClass: "w-100" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 mb-3" }, [
                              _c(
                                "div",
                                { staticClass: "row" },
                                [
                                  _c("block-headline", {
                                    staticClass: "col-12",
                                    attrs: {
                                      icon: "clock",
                                      text: "Öffnungszeiten"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "FormulateInput",
                                    {
                                      staticClass: "col-12",
                                      attrs: { name: "openings", type: "group" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { id: "accordion" } },
                                        _vm._l(7, function(opening, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index + 1,
                                              staticClass: "card"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "card-header p-0",
                                                  attrs: {
                                                    id:
                                                      "accordion__heading-" +
                                                      index +
                                                      1
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mb-0 row no-gutters p-3 col-12 justify-content-between heading__wrapper",
                                                      class:
                                                        index + 1 === 1
                                                          ? ""
                                                          : "collapsed",
                                                      attrs: {
                                                        "data-target":
                                                          "#collapse-" +
                                                          index +
                                                          1,
                                                        "data-toggle":
                                                          "collapse"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "mr-1 mb-0"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayWeekday(
                                                                  index + 1
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row no-gutters"
                                                        },
                                                        _vm._l(
                                                          _vm.element
                                                            .openings[0][
                                                            index + 1
                                                          ],
                                                          function(hour) {
                                                            return Object.keys(
                                                              _vm.element
                                                                .openings[0][
                                                                index + 1
                                                              ]
                                                            ).length !== 0
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1 mb-0 accordion__headline"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                            " +
                                                                        _vm._s(
                                                                          hour.start
                                                                        ) +
                                                                        " : " +
                                                                        _vm._s(
                                                                          hour.end
                                                                        ) +
                                                                        "\n                                                        "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "collapsed collapse",
                                                  class:
                                                    index + 1 === 1
                                                      ? "show"
                                                      : "",
                                                  attrs: {
                                                    id: "collapse-" + index + 1,
                                                    "data-parent": "#accordion"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "card-body"
                                                    },
                                                    [
                                                      _c(
                                                        "FormulateInput",
                                                        {
                                                          attrs: {
                                                            name: String(
                                                              index + 1
                                                            ),
                                                            repeatable: true,
                                                            value: [],
                                                            "add-label":
                                                              "+ Zeiten",
                                                            type: "group"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "weekday row"
                                                            },
                                                            [
                                                              _c(
                                                                "FormulateInput",
                                                                {
                                                                  staticClass:
                                                                    "col-6 mb-0",
                                                                  attrs: {
                                                                    label:
                                                                      "Öffnung",
                                                                    name:
                                                                      "start",
                                                                    type:
                                                                      "time",
                                                                    validation:
                                                                      "required",
                                                                    "validation-name":
                                                                      "Öffnungszeit"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "FormulateInput",
                                                                {
                                                                  staticClass:
                                                                    "col-6 mb-0",
                                                                  attrs: {
                                                                    label:
                                                                      "Schließung",
                                                                    name: "end",
                                                                    type:
                                                                      "time",
                                                                    validation:
                                                                      "required",
                                                                    "validation-name":
                                                                      "Schließungszeit"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("form-buttons", {
                                    attrs: { isLoading: _vm.isSubmitting },
                                    on: { cancel: _vm.cancelEdit }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("hr", { staticClass: "w-100" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 mb-3" }, [
                              _c(
                                "div",
                                { staticClass: "row" },
                                [
                                  _c("block-headline", {
                                    staticClass: "col-12",
                                    attrs: {
                                      icon: "clock",
                                      text: "Hybridmarkt"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("FormulateInput", {
                                    staticClass: "col-6",
                                    attrs: {
                                      options: [
                                        { name: "Ja", value: 1 },
                                        { name: "Nein", value: 0 }
                                      ],
                                      label: "Hybridmarkt",
                                      name: "hybrid_market",
                                      placeholder: "Hybridmarkt",
                                      type: "multiselect",
                                      validation: "required",
                                      "validation-name": "Hybridmarkt"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "FormulateInput",
                                    {
                                      staticClass: "col-12",
                                      attrs: {
                                        name: "hybrid_openings",
                                        type: "group"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { id: "accordion" } },
                                        _vm._l(7, function(opening, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index + 1,
                                              staticClass: "card"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "card-header p-0",
                                                  attrs: {
                                                    id:
                                                      "accordion__heading-" +
                                                      index +
                                                      1
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mb-0 row no-gutters p-3 col-12 justify-content-between heading__wrapper",
                                                      class:
                                                        index + 1 === 1
                                                          ? ""
                                                          : "collapsed",
                                                      attrs: {
                                                        "data-target":
                                                          "#collapse-" +
                                                          index +
                                                          1,
                                                        "data-toggle":
                                                          "collapse"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "mr-1 mb-0"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayWeekday(
                                                                  index + 1
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row no-gutters"
                                                        },
                                                        _vm._l(
                                                          _vm.element
                                                            .hybrid_openings[0][
                                                            index + 1
                                                          ],
                                                          function(hour) {
                                                            return Object.keys(
                                                              _vm.element
                                                                .hybrid_openings[0][
                                                                index + 1
                                                              ]
                                                            ).length !== 0
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1 mb-0 accordion__headline"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                            " +
                                                                        _vm._s(
                                                                          hour.start
                                                                        ) +
                                                                        " : " +
                                                                        _vm._s(
                                                                          hour.end
                                                                        ) +
                                                                        "\n                                                        "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "collapsed collapse",
                                                  class:
                                                    index + 1 === 1
                                                      ? "show"
                                                      : "",
                                                  attrs: {
                                                    id: "collapse-" + index + 1,
                                                    "data-parent": "#accordion"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "card-body"
                                                    },
                                                    [
                                                      _c(
                                                        "FormulateInput",
                                                        {
                                                          attrs: {
                                                            name: String(
                                                              index + 1
                                                            ),
                                                            repeatable: true,
                                                            value: [],
                                                            "add-label":
                                                              "+ Zeiten",
                                                            type: "group"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "weekday row"
                                                            },
                                                            [
                                                              _c(
                                                                "FormulateInput",
                                                                {
                                                                  staticClass:
                                                                    "col-6 mb-0",
                                                                  attrs: {
                                                                    label:
                                                                      "Öffnung",
                                                                    name:
                                                                      "start",
                                                                    type:
                                                                      "time",
                                                                    validation:
                                                                      "required",
                                                                    "validation-name":
                                                                      "Öffnungszeit"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "FormulateInput",
                                                                {
                                                                  staticClass:
                                                                    "col-6 mb-0",
                                                                  attrs: {
                                                                    label:
                                                                      "Schließung",
                                                                    name: "end",
                                                                    type:
                                                                      "time",
                                                                    validation:
                                                                      "required",
                                                                    "validation-name":
                                                                      "Schließungszeit"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("form-buttons", {
                                    attrs: { isLoading: _vm.isSubmitting },
                                    on: { cancel: _vm.cancelEdit }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("hr", { staticClass: "w-100" }),
                            _vm._v(" "),
                            _vm.userRole !== "merchant"
                              ? _c("div", { staticClass: "col-12 mb-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "row" },
                                    [
                                      _c("block-headline", {
                                        staticClass: "col-12",
                                        attrs: {
                                          icon: "cog",
                                          text: "Einstellungen"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-12" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "alert alert-success",
                                            attrs: { role: "alert" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        Diese Einstellungen sind nur für GHH Mitarbeiter und Administratoren sichtbar!\n                                    "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "FormulateInput",
                                        {
                                          staticClass: "col-12",
                                          attrs: {
                                            name: "settings",
                                            type: "group"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "row" },
                                            [
                                              _c("FormulateInput", {
                                                staticClass: "col-12 col-md-6",
                                                attrs: {
                                                  label: "Mitarbeiteranzahl",
                                                  name: "employees",
                                                  step: "1",
                                                  type: "number"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("FormulateInput", {
                                                staticClass: "col-12 col-md-6",
                                                attrs: {
                                                  label:
                                                    "Zuständiger Verkaufsberater",
                                                  name: "sales_advisor",
                                                  type: "text"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("FormulateInput", {
                                                staticClass: "col-12 col-md-6",
                                                attrs: {
                                                  options: [
                                                    { name: "Ja", value: 1 },
                                                    { name: "Nein", value: 0 }
                                                  ],
                                                  label:
                                                    "Werbenutzung über 50%",
                                                  name: "advertising_usage",
                                                  type: "multiselect",
                                                  value: {
                                                    name: "Nein",
                                                    value: 0
                                                  },
                                                  placeholder:
                                                    "Bitte auswählen",
                                                  validation: "required"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("FormulateInput", {
                                                staticClass: "col-12 col-md-6",
                                                attrs: {
                                                  options: [
                                                    { name: "Ja", value: 1 },
                                                    { name: "Nein", value: 0 }
                                                  ],
                                                  label: "Werbescreen",
                                                  name: "advertising_screen",
                                                  type: "multiselect",
                                                  value: {
                                                    name: "Nein",
                                                    value: 0
                                                  },
                                                  placeholder:
                                                    "Bitte auswählen",
                                                  validation: "required"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("FormulateInput", {
                                                staticClass: "col-6",
                                                attrs: {
                                                  label: "Kühlmöbelanzahl",
                                                  name: "refrigerated_displays",
                                                  step: "0.01",
                                                  type: "number"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("FormulateInput", {
                                                staticClass: "col-6",
                                                attrs: {
                                                  label: "Kühlmöbellaufmeter",
                                                  name:
                                                    "refrigerated_displays_length",
                                                  step: "0.01",
                                                  type: "number"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("FormulateInput", {
                                                staticClass: "col-6",
                                                attrs: {
                                                  label: "Eröffnungsdatum",
                                                  name: "opening_date",
                                                  type: "date"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("FormulateInput", {
                                                staticClass: "col-6",
                                                attrs: {
                                                  label: "Schließungsdatum",
                                                  name: "closing_date",
                                                  type: "date"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("FormulateInput", {
                                                staticClass: "col-12 col-md-6",
                                                attrs: {
                                                  label: "Anzahl Trainings",
                                                  name: "number_trainings",
                                                  step: "1",
                                                  placeholder:
                                                    "Anzahl Trainings",
                                                  type: "number"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("form-buttons", {
                            attrs: { isLoading: _vm.isSubmitting },
                            on: { cancel: _vm.cancelEdit }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }